/**
 * Do not edit directly
 * Generated on Wed, 02 Mar 2022 14:57:41 GMT
 **/
export const theme = {
  "background": {
    "body": "#ffffff",
    "main": "#f7f7f7",
    "bright": "#ffffff",
    "muted": "#f4f4f4"
  }
};
export const color = {
  "black": "#000000",
  "white": "#ffffff",
  "gray": "#9e9e9e",
  "grey": "#9e9e9e",
  "offWhite": "#f7f7f7",
  "bright": "#f7f7f7",
  "light": "#dbdbdb",
  "neutral": "#4f5361",
  "dark": "#3d464d",
  "orange": "#ff6900",
  "navigation": "#202945",
  "skyBlue": "#009bdf",
  "steel": "#5b6770",
  "metal": "#637893",
  "sand": "#f4f4f4",
  "silver": "#e2e2e2",
  "stone": "#bebebe",
  "ash": "#a0a0a0",
  "slate": "#707070",
  "onyx": "#526980",
  "charcoal": "#282828",
  "moonlight": "#1a242f",
  "midnight": "#202945",
  "darkness": "#161f27",
  "navy": "#0d2d42",
  "aqua": "#3bafda",
  "ocean": "#4a89dc",
  "mint": "#37bc9b",
  "grass": "#8cc152",
  "sunflower": "#f6b042",
  "bittersweet": "#eb6845",
  "grapefruit": "#da4453",
  "carnation": "#d770ad",
  "lavender": "#967adc",
  "mountain": "#9678b6",
  "info": "#4a89dc",
  "positive": "#4a89dc",
  "success": "#8cc152",
  "negative": "#da4453",
  "danger": "#da4453",
  "error": "#da4453",
  "warning": "#f6b042",
  "empty": "#cccdcc",
  "disabled": "#bebebe",
  "background": "#f7f7f7",
  "backgroundDark": "#e2e2e2",
  "presentation": "#5b6770",
  "bullhorn": "#ff6900",
  "pulse": "#3bafda",
  "company": "#3399dd",
  "candidate": "#44bb77",
  "lead": "#aa6699",
  "contact": "#ffaa44",
  "clientcontact": "#ffaa44",
  "opportunity": "#662255",
  "job": "#bb5566",
  "joborder": "#bb5566",
  "submission": "#a9adbb",
  "sendout": "#747884",
  "placement": "#0b344f",
  "note": "#747884",
  "contract": "#454ea0",
  "jobCode": "#696d79",
  "earnCode": "#696d79",
  "invoiceStatement": "#696d79",
  "billableCharge": "#696d79",
  "payableCharge": "#696d79",
  "user": "#696d79",
  "corporateUser": "#696d79",
  "distributionList": "#696d79",
  "credential": "#696d79",
  "person": "#696d79",
  "shade": {
    "black": "#000000",
    "white": "#cccccc",
    "gray": "#7e7e7e",
    "grey": "#7e7e7e",
    "offWhite": "#c5c5c5",
    "bright": "#c5c5c5",
    "light": "#afafaf",
    "neutral": "#3f424d",
    "dark": "#30383d",
    "orange": "#cc5400",
    "navigation": "#192037",
    "skyBlue": "#007cb2",
    "steel": "#485259",
    "metal": "#4f6075",
    "sand": "#c3c3c3",
    "silver": "#b4b4b4",
    "stone": "#989898",
    "ash": "#808080",
    "slate": "#595959",
    "onyx": "#415466",
    "charcoal": "#202020",
    "moonlight": "#141c25",
    "midnight": "#192037",
    "darkness": "#11181f",
    "navy": "#0a2434",
    "aqua": "#2f8cae",
    "ocean": "#3b6db0",
    "mint": "#2c967c",
    "grass": "#709a41",
    "sunflower": "#c48c34",
    "bittersweet": "#bc5337",
    "grapefruit": "#ae3642",
    "carnation": "#ac598a",
    "lavender": "#7861b0",
    "mountain": "#786091",
    "info": "#3b6db0",
    "positive": "#3b6db0",
    "success": "#709a41",
    "negative": "#ae3642",
    "danger": "#ae3642",
    "error": "#ae3642",
    "warning": "#c48c34",
    "empty": "#a3a4a3",
    "disabled": "#989898",
    "background": "#c5c5c5",
    "backgroundDark": "#b4b4b4",
    "presentation": "#485259",
    "bullhorn": "#cc5400",
    "pulse": "#2f8cae",
    "company": "#287ab0",
    "candidate": "#36955f",
    "lead": "#88517a",
    "contact": "#cc8836",
    "clientcontact": "#cc8836",
    "opportunity": "#511b44",
    "job": "#954451",
    "joborder": "#954451",
    "submission": "#878a95",
    "sendout": "#5c6069",
    "placement": "#08293f",
    "note": "#5c6069",
    "contract": "#373e80",
    "jobCode": "#545760",
    "earnCode": "#545760",
    "invoiceStatement": "#545760",
    "billableCharge": "#545760",
    "payableCharge": "#545760",
    "user": "#545760",
    "corporateUser": "#545760",
    "distributionList": "#545760",
    "credential": "#545760",
    "person": "#545760"
  },
  "tint": {
    "black": "#333333",
    "white": "#ffffff",
    "gray": "#b1b1b1",
    "grey": "#b1b1b1",
    "offWhite": "#f8f8f8",
    "bright": "#f8f8f8",
    "light": "#e2e2e2",
    "neutral": "#727580",
    "dark": "#636b70",
    "orange": "#ff8733",
    "navigation": "#4c536a",
    "skyBlue": "#33afe5",
    "steel": "#7b858c",
    "metal": "#8293a8",
    "sand": "#f6f6f6",
    "silver": "#e7e7e7",
    "stone": "#cbcbcb",
    "ash": "#b3b3b3",
    "slate": "#8c8c8c",
    "onyx": "#748799",
    "charcoal": "#535353",
    "moonlight": "#474f58",
    "midnight": "#4c536a",
    "darkness": "#444b52",
    "navy": "#3d5767",
    "aqua": "#62bfe1",
    "ocean": "#6ea0e3",
    "mint": "#5fc9af",
    "grass": "#a3cd74",
    "sunflower": "#f7bf67",
    "bittersweet": "#ef866a",
    "grapefruit": "#e16975",
    "carnation": "#df8cbd",
    "lavender": "#ab94e3",
    "mountain": "#ab93c4",
    "info": "#6ea0e3",
    "positive": "#6ea0e3",
    "success": "#a3cd74",
    "negative": "#e16975",
    "danger": "#e16975",
    "error": "#e16975",
    "warning": "#f7bf67",
    "empty": "#d6d7d6",
    "disabled": "#cbcbcb",
    "background": "#f8f8f8",
    "backgroundDark": "#e7e7e7",
    "presentation": "#7b858c",
    "bullhorn": "#ff8733",
    "pulse": "#62bfe1",
    "company": "#5bade3",
    "candidate": "#69c892",
    "lead": "#bb84ad",
    "contact": "#ffbb69",
    "clientcontact": "#ffbb69",
    "opportunity": "#844e77",
    "job": "#c87784",
    "joborder": "#c87784",
    "submission": "#babdc8",
    "sendout": "#8f939c",
    "placement": "#3b5c72",
    "note": "#8f939c",
    "contract": "#6a71b3",
    "jobCode": "#878a93",
    "earnCode": "#878a93",
    "invoiceStatement": "#878a93",
    "billableCharge": "#878a93",
    "payableCharge": "#878a93",
    "user": "#878a93",
    "corporateUser": "#878a93",
    "distributionList": "#878a93",
    "credential": "#878a93",
    "person": "#878a93"
  },
  "contrast": {
    "black": "#ffffff",
    "white": "#3d464d",
    "gray": "#3d464d",
    "grey": "#3d464d",
    "offWhite": "#3d464d",
    "bright": "#3d464d",
    "light": "#3d464d",
    "neutral": "#ffffff",
    "dark": "#ffffff",
    "orange": "#3d464d",
    "navigation": "#ffffff",
    "skyBlue": "#ffffff",
    "steel": "#ffffff",
    "metal": "#ffffff",
    "sand": "#3d464d",
    "silver": "#3d464d",
    "stone": "#3d464d",
    "ash": "#3d464d",
    "slate": "#ffffff",
    "onyx": "#ffffff",
    "charcoal": "#ffffff",
    "moonlight": "#ffffff",
    "midnight": "#ffffff",
    "darkness": "#ffffff",
    "navy": "#ffffff",
    "aqua": "#3d464d",
    "ocean": "#ffffff",
    "mint": "#3d464d",
    "grass": "#ffffff",
    "sunflower": "#ffffff",
    "bittersweet": "#ffffff",
    "grapefruit": "#ffffff",
    "carnation": "#ffffff",
    "lavender": "#ffffff",
    "mountain": "#ffffff",
    "info": "#ffffff",
    "positive": "#ffffff",
    "success": "#ffffff",
    "negative": "#ffffff",
    "danger": "#ffffff",
    "error": "#ffffff",
    "warning": "#ffffff",
    "empty": "#3d464d",
    "disabled": "#3d464d",
    "background": "#3d464d",
    "backgroundDark": "#3d464d",
    "presentation": "#ffffff",
    "bullhorn": "#3d464d",
    "pulse": "#3d464d",
    "company": "#ffffff",
    "candidate": "#ffffff",
    "lead": "#ffffff",
    "contact": "#ffffff",
    "clientcontact": "#ffffff",
    "opportunity": "#ffffff",
    "job": "#ffffff",
    "joborder": "#ffffff",
    "submission": "#3d464d",
    "sendout": "#ffffff",
    "placement": "#ffffff",
    "note": "#ffffff",
    "contract": "#ffffff",
    "jobCode": "#ffffff",
    "earnCode": "#ffffff",
    "invoiceStatement": "#ffffff",
    "billableCharge": "#ffffff",
    "payableCharge": "#ffffff",
    "user": "#ffffff",
    "corporateUser": "#ffffff",
    "distributionList": "#ffffff",
    "credential": "#ffffff",
    "person": "#ffffff"
  },
  "pale": {
    "black": "#e6e6e6",
    "white": "#e6e6e6",
    "gray": "#e6e6e6",
    "grey": "#e6e6e6",
    "offWhite": "#e6e6e6",
    "bright": "#e6e6e6",
    "light": "#e6e6e6",
    "neutral": "#e3e4e8",
    "dark": "#e3e6e8",
    "orange": "#ffe1cc",
    "navigation": "#dce1ef",
    "skyBlue": "#ccefff",
    "steel": "#e3e6e8",
    "metal": "#e1e5ea",
    "sand": "#e6e6e6",
    "silver": "#e6e6e6",
    "stone": "#e6e6e6",
    "ash": "#e6e6e6",
    "slate": "#e6e6e6",
    "onyx": "#e0e6eb",
    "charcoal": "#e6e6e6",
    "moonlight": "#dee5ed",
    "midnight": "#dce1ef",
    "darkness": "#dee6ed",
    "navy": "#d4e9f7",
    "aqua": "#d4edf7",
    "ocean": "#d4e3f7",
    "mint": "#d8f3ed",
    "grass": "#e6f2d9",
    "sunflower": "#fdebce",
    "bittersweet": "#fadad1",
    "grapefruit": "#f7d4d8",
    "carnation": "#f4d7e8",
    "lavender": "#dfd7f4",
    "mountain": "#e5deed",
    "info": "#d4e3f7",
    "positive": "#d4e3f7",
    "success": "#e6f2d9",
    "negative": "#f7d4d8",
    "danger": "#f7d4d8",
    "error": "#f7d4d8",
    "warning": "#fdebce",
    "empty": "#e5e6e5",
    "disabled": "#e6e6e6",
    "background": "#e6e6e6",
    "backgroundDark": "#e6e6e6",
    "presentation": "#e3e6e8",
    "bullhorn": "#ffe1cc",
    "pulse": "#d4edf7",
    "company": "#d3e9f8",
    "candidate": "#daf1e4",
    "lead": "#eddee9",
    "contact": "#ffe8cc",
    "clientcontact": "#ffe8cc",
    "opportunity": "#f2d9ec",
    "job": "#f0dbde",
    "joborder": "#f0dbde",
    "submission": "#e3e4e8",
    "sendout": "#e4e5e7",
    "placement": "#d2e9f9",
    "note": "#e4e5e7",
    "contract": "#dbddf0",
    "jobCode": "#e4e5e7",
    "earnCode": "#e4e5e7",
    "invoiceStatement": "#e4e5e7",
    "billableCharge": "#e4e5e7",
    "payableCharge": "#e4e5e7",
    "user": "#e4e5e7",
    "corporateUser": "#e4e5e7",
    "distributionList": "#e4e5e7",
    "credential": "#e4e5e7",
    "person": "#e4e5e7"
  }
};
export const size = {
  "space": {
    "none": "0rem",
    "px": "1rem",
    "xs": "0.25rem",
    "sm": "0.5rem",
    "md": "1rem",
    "lg": "1.25rem",
    "xl": "1.5rem"
  },
  "border": {
    "width": {
      "none": "0rem",
      "thin": "1rem",
      "thick": "2rem",
      "base": "0rem"
    },
    "radius": {
      "round": "0.4rem",
      "square": "0rem",
      "circle": "99999rem",
      "base": "0.4rem"
    }
  }
};
export const spacing = {
  "none": "0",
  "px": "1px",
  "xs": "0.25rem",
  "sm": "0.5rem",
  "md": "1rem",
  "lg": "1.25rem",
  "xl": "1.5rem",
  "2xl": "2rem",
  "3xl": "3rem"
};
export const font = {
  "weight": {
    "hairline": 100,
    "thin": 200,
    "light": 300,
    "normal": 400,
    "medium": 500,
    "semibold": 600,
    "bold": 700,
    "extrabold": 800,
    "heavy": 900
  },
  "family": {
    "body": "'Montserrat', Helvetica, Arial, sans-serif",
    "mono": "'Fira Code', Menlo, Monaco, Consolas, \"Courier New\", monospace",
    "base": "'Montserrat', Helvetica, Arial, sans-serif"
  },
  "size": {
    "base": "10px",
    "body": "1.3rem",
    "xs": "1.0rem",
    "sm": "1.2rem",
    "md": "1.3rem",
    "lg": "1.6rem",
    "xl": "2.0rem",
    "2xl": "2.6rem",
    "3xl": "3.2rem",
    "4xl": "4rem"
  },
  "spacing": {
    "tighter": "-0.05em",
    "tight": "-0.025em",
    "normal": "0",
    "wide": "0.025em",
    "wider": "0.05em",
    "widest": "0.1em"
  },
  "height": {
    "normal": "normal",
    "none": "1",
    "shorter": "1.25",
    "short": "1.375",
    "base": "1.5",
    "tall": "1.625",
    "taller": "2"
  },
  "color": {
    "base": "#3d464d",
    "secondary": "#dbdbdb",
    "link": "#4a89dc"
  }
};
export const borderWidth = {
  "none": "0",
  "thin": "1px",
  "thick": "2px"
};
export const borderRadius = {
  "round": "0.4rem",
  "square": "0rem",
  "circle": 99999,
  "default": "0.4rem"
};
export const shadow = {
  "1": "0 1px 2px rgba(0, 0, 0, 0.15)",
  "2": "0 3px 7px rgba(0, 0, 0, 0.15)",
  "3": "0px 4px 10px rgba(0, 0, 0, 0.25)",
  "4": "0px 16px 28px 0 rgba(0, 0, 0, 0.25)",
  "5": "0px 27px 24px 0 rgba(0, 0, 0, 0.25)",
  "multi": "0 -1px 3px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
  "card": "0 -1px 3px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
  "popover": "0 1px 2px rgba(0, 0, 0, 0.15)"
};
export const button = {
  "primary": {
    "padding": "1rem",
    "font-size": "1.6rem",
    "background-color": "#4a89dc",
    "color": "#ffffff"
  },
  "secondary": {
    "padding": "1rem",
    "font-size": "1.6rem",
    "background-color": "#ffffff",
    "border-color": "#4a89dc",
    "border-width": "0rem",
    "border-radius": "0.4rem",
    "color": "#4a89dc"
  }
};
export const tooltip = {
  "padding": "1rem",
  "border-radius": "0.4rem",
  "background-color": "var(--color-tint-black)"
};